import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import fetchSearch from '../../actions/fetch-search';
import { pageOpened } from '../../actions/page-opened';
import search, { MIN_QUERY_LENGTH } from '../../actions/search';
import { setIsLoading } from '../../actions/set-is-loading';
import AnimatedLoader from '../../components/animated-loader';
import Page from '../../components/page';
import NoSearchResults from '../../components/no-search-results';
import DefaultDesktopLayout from '../../components/default-desktop-layout';
import { getIsAppLoaded } from '../../selectors/is-app-loaded-selectors';
import { SEARCH_RESULTS } from '../../services/detect-route';
import { decodeQuery } from '../../services/search-page-url';
import SearchResultsList from '../search-results-list';
import PageMetadata from '../../components/page-metadata';
import AppLoaded from '../../components/app-loaded';
import { getSearch } from '../../selectors/search-selectors';
import { getIsSearchLoading } from '../../selectors/is-loading-selectors';

export class SearchResultsPage extends Component {
  componentWillMount() {
    const { query, isAppLoaded } = this.props;
    if (query && query.length >= MIN_QUERY_LENGTH && isAppLoaded) {
      this.props.setIsLoading('search', '', true);
    }
  }

  componentDidMount() {
    this.props.search(this.props.query);
    this.props.pageOpened({ page: SEARCH_RESULTS });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.query !== nextProps.query) {
      this.props.search(nextProps.query);
      this.props.setIsLoading('search', '', true);
    }
  }

  render() {
    const { searchResults, location, isLoading } = this.props;
    const hasResults = Boolean(get(searchResults.posts, 'length', 0));
    return (
      <Page noSpacing={!hasResults}>
        <PageMetadata noIndex />
        <DefaultDesktopLayout>
          <AnimatedLoader isLoading={isLoading} isAnimated={true}>
            {hasResults ? (
              <SearchResultsList posts={searchResults.posts} query={location.query.query} />
            ) : (
              <NoSearchResults />
            )}
          </AnimatedLoader>
          {!isLoading && <AppLoaded />}
        </DefaultDesktopLayout>
      </Page>
    );
  }
}

SearchResultsPage.fetchData = ({ store, params: { query: queryParam }, query }) => {
  if (queryParam === 'posts' && query.query) {
    return Promise.reject({ status: 404 });
  }

  if (queryParam && queryParam.length >= MIN_QUERY_LENGTH) {
    return store.dispatch(fetchSearch(decodeQuery(queryParam)));
  }
};

SearchResultsPage.propTypes = {
  query: PropTypes.string.isRequired,
  searchResults: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isAppLoaded: PropTypes.bool.isRequired,
  search: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  pageOpened: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  query: decodeQuery(ownProps.params.query || ''),
  searchResults: getSearch(state),
  isLoading: getIsSearchLoading(state),
  isAppLoaded: getIsAppLoaded(state),
});

const mapDispatchToProps = {
  search,
  pageOpened,
  setIsLoading,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchResultsPage);
